/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_TagsInputs */



/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Event_Group_Sync_Property_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_tags = /** @type {((inputs?: Event_Group_Sync_Property_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Tags")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tags")
	return /** @type {LocalizedString} */ ("Tags")
});